angular.module('salesPath2')
    .service('searchHelper', ['ihestiaSsoBaseInfoHelper', 'UserCharacterTypeConstants', 'dataContainerHelper',
        function (ihestiaSsoBaseInfoHelper, UserCharacterTypeConstants, dataContainerHelper) {
            var SearchHelper = function () {
                var self = this;
                this.CLIENT_SEARCH = 'clientSearch';
                this.CLIENT_AND_VEHICLE_SEARCH = 'clientAndVehicleSearch';

                this.activeTabName = this.CLIENT_AND_VEHICLE_SEARCH;
                this.allowedCharacters = [
                    UserCharacterTypeConstants.CHARACTER_TYPE_WORKER,
                    UserCharacterTypeConstants.CHARACTER_TYPE_PRO_CONTACT_WORKER,
                    UserCharacterTypeConstants.CHARACTER_TYPE_DIRECT_SALE
                ];
                
                this.tplData = {
                    searchData: {
                        pesel: null,
                        registration: null
                    },
                    allowed: this.allowedCharacters.indexOf(ihestiaSsoBaseInfoHelper.getUser().getCurrentCharacter().type) > -1
                };

                /**
                 * reakcja na akcje w aplikacji
                 * @param  {String} actionName nazwa wykonanej akcji
                 */
                this._afterAction = function(actionName) {
                  switch (actionName) {
                    case 'apkDetailsSet':
                        var apkDetails = dataContainerHelper.getApkDetails();
                        self.tplData.searchData.registration = apkDetails.attributes && apkDetails.attributes.vehicleRegistrationNumber ? apkDetails.attributes.vehicleRegistrationNumber : null;
                        break;
                    default:
                  }
                };                
            };
            return new SearchHelper();
        }])
        .run(['searchHelper', 'actionHelper',
          function(searchHelper, actionHelper) {
            actionHelper.registerHelper('searchHelper', searchHelper, [
                'apkDetailsSet'
            ]);
          }
        ]);